import { resolveColumns } from "./columns";
import { isKeikasochi, KEIKA_COL, resolveKeikaName } from "./keikasochi";
import { boolFromJa, isBetween, normalizeValue } from "./utils";

export function buildKubunsMap(chiikiRows, keikaRows, law, date, keikasochi = false) {
  let pairs;
  if (isKeikasochi(law, date, keikasochi)) {
    pairs = keikaRows
      .filter(
        (row) =>
          normalizeValue(row[KEIKA_COL.LAW]) === normalizeValue(law) &&
          isBetween(date, row[KEIKA_COL.BEGIN_DATE], row[KEIKA_COL.END_DATE]) &&
          boolFromJa(row[KEIKA_COL.KEIKA]) === keikasochi,
      )
      .map((row) => [normalizeValue(row[KEIKA_COL.CODE]), normalizeValue(row[KEIKA_COL.NAME])]);
  } else {
    const [codeCol, nameCol] = resolveColumns(law, date, keikasochi);
    pairs = chiikiRows.map((row) => [normalizeValue(row[codeCol]), normalizeValue(row[nameCol])]);
  }

  const map = new Map();
  pairs
    .filter(([code]) => code)
    .sort(([left], [right]) => left.localeCompare(right))
    .forEach(([code, name]) => map.set(code, name));
  return map;
}

export function resolveChiikiName(chiikiRows, keikaRows, law, date, keikasochi, filteredRows) {
  if (isKeikasochi(law, date, keikasochi)) {
    return resolveKeikaName(filteredRows, law, date, keikasochi, keikaRows);
  }
  const [, nameCol] = resolveColumns(law, date, keikasochi);
  return filteredRows.length ? normalizeValue(filteredRows[0][nameCol]) : null;
}
